import React from 'react';

export const PageNotFound = () => {
    return (
        <div className='mt-5'>
            <h4>Page Not Found!</h4>
        </div>
    );
}